import "bootstrap/dist/css/bootstrap.min.css"

import "jquery/dist/jquery.min.js"
import "popper.js/dist/popper.min.js"
import "bootstrap/dist/js/bootstrap.min"
